<template>
  <div class="tw-bg-gray-100 tw-h-auto">
    <AppBar />
    <div class="tw-mt-12 tw-ml-14 tw-text-6xl tw-font-bold">
      Terms of Service
    </div>
    <v-card class="tw-ml-10 tw-mr-10 tw-mt-10 tw-justify-normal">
      <v-card-text class="tw-ml-10 tw-mr-10 tw-mt-10 tw-text-gray-500 tw-mb-10">
        By subscribing to the website http://www.greenmedicineworks.com, you
        accept and agree to be bound by these terms of service. In addition,
        when using this websites particular service, you shall be subject to all
        guidelines or rules applicable to our services, which may be modified
        from time to time. If you do not agree with any of these terms, you are
        prohibited from subscribing to the services offered.
        <p class="tw-font-bold tw-text-2xl tw-mt-4">Subscription Service</p>
        <ul class="tw-list-disc tw-pl-12 tw-mt-4">
          <li>
            Your credit card will be charged every month on or about the same
            day of your original service plan purchase.
          </li>
          <li>
            You may cancel your subscription at any time by emailing us at
            customersupport@greenmedicineworks.com include the word Cancel in
            the subject box.
          </li>
          <li>
            There will not be any refund once your credit card has been charged
            for the monthly renewal. Your subscription will be terminated at the
            end of its current billing cycle.
          </li>
        </ul>

        <p class="tw-font-bold tw-text-2xl tw-mt-4">Accuracy of materials</p>

        <p class="tw-mt-4">
          The information appearing on Green Medicine Encyclopedia website could
          include technical, typographical, or photographic errors.
          Greenmedicineworks.com does not warrant that any of the materials on
          its website are accurate, complete or current. Greenmedicineworks.com
          may make changes to the materials contained on its website at any time
          without notice. However Greenmedicineworks.com does not make any
          commitment to update the materials. The nutrient content of foods and
          herbs listed are derived from the USDA National Nutrient Database
          published by the United States Agricultural Research Service or the
          International Network of Food Data Systems. In some cases nutrients
          may be listed without specific quantities being mentioned because the
          value/quantity has not yet been measured.
        </p>

        <p class="tw-mt-4">
          The materials contained in this website are protected by applicable
          copyright and trademark law.
        </p>
        <p class="tw-font-bold tw-text-2xl tw-mt-4 tw-mb-4">Limitations</p>

        <p class="tw-mb-4">
          In no event shall Greenmedicineworks.com or its contributors be liable
          for any damages (including, without limitation, damages for loss of
          data or profit, or due to business interruption) arising out of the
          use or inability to use the information offered through Green Medicine
          Encyclopedia website.
        </p>

        <p class="tw-font-bold tw-text-2xl tw-mt-4 tw-mb-4">Disclaimer</p>

        <p>
          Information on this website, Greenmedicineworks.com has not been
          evaluated by the Food and Drug Association and is provided for
          educational purposes only and not intended to be a substitute for the
          advice provided by your physician or other health care professional.
          You should not use the information on this web site for diagnosing or
          treating a health problem or disease and seek the advice of your
          health care provider or a health professional that is experienced and
          knowledgeable in the field of nutrition before making any health
          related decision on your own.
        </p>

        <p class="tw-mt-4">
          Research, when sited, supporting the information in this database are
          based on abstracts of peer-reviewed journals and or layman’s
          publications. In many cases the editors of the content have not
          scrutinized the full text associated with the abstracts as this is
          beyond the scope of presenting the information.
        </p>
      </v-card-text>
    </v-card>
  </div>
  <Footer />
</template>

<script setup lang="ts">
import { useSeo } from "@/composables/useSeo";

useSeo({
  title: "Terms of Service",
});
</script>

<route lang="yaml">
meta:
  layout: non-auth.vue
</route>
